export default function (text) {
    let cleanText = ""
    for (var i = 0; i < text.length; i++) {
        let allowedCharacters = ["Á", "A", "a", "á", "B", "b", "C", "c", "D", "d", "É", "E", "e", "é", "F", "f", "G", "g", "H", "h", "I", "Í", "i", "í", "J",
            "j", "K", "k", "L", "l", "M", "m", "N", "n", "Ñ", "ñ", "Ó", "O", "o", "ó", "P", "p", "Q", "q", "R", "r", "S", "s", "T", "t", "Ú", "U", "u", "ú", "V", "v", "W", "w", "X", "x", "Y", "y", "Z", "z",
            "-", "_", " ", ":", ".", ",", "!", "¡", "?", "¿", "@", "#", "$", "%", "&", "/", "(", ")", "=", "\"", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "'"]
        const isCharacterAllowed = allowedCharacters.includes(text.charAt(i))
        if (isCharacterAllowed) cleanText += text.charAt(i)
    }
    return cleanText.trim()
}
